import CONSTANTS from "../CONSTANTS";

export const actionGetKitsList = (page = 0, limit = 5 , search=null) => ({
  type: CONSTANTS.KITS_GET_LIST,
  page,
  limit,
  search
});

export const actionGetKit = (kitId) => ({
  type: CONSTANTS.KITS_GET,
  kitId
});

export const actionUpdateKitInList = (kitId, data) => ({
  type: CONSTANTS.KITS_UPDATE_IN_LIST,
  kitId,
  data
});

export const actionSetKitsList = (kits) => ({
  type: CONSTANTS.KITS_SET_LIST,
  kits,
});

export const actionSetEditKit = (kit) => ({
  type: CONSTANTS.KITS_SET_EDIT,
  kit
});

export const actionKitSubmitEdition = (data) => ({
  type: CONSTANTS.KITS_SUBMIT_EDIT,
  data
})

export const actionKitSubmitForm = (data) => ({
  type: CONSTANTS.KITS_SUBMIT_FORM,
  data
});

export const actionDeleteKit = (kitId) => ({
  type: CONSTANTS.KIT_DELETE,
  kitId
});

export const actionGetKitTypes = () => ({
  type: CONSTANTS.KITS_GET_TYPES,
});

export const actionSetKitTypes = (types) => ({
  type: CONSTANTS.KITS_SET_TYPES,
  types
});

export const actionGetKitsCount = () => ({
  type: CONSTANTS.KITS_GET_COUNT_BY_TYPE
});

export const actionSetKitsCount = (count) => ({
  type: CONSTANTS.KITS_SET_COUNT_BY_TYPE,
  count
});

export const actionGetPatientKits = (page = 0, limit = 5 , search=null) => ({
  type: CONSTANTS.KITS_PATIENTS_GET,
  page,
  limit,
  search
});

export const actionSetPatientKits = (kits) => ({
  type: CONSTANTS.KITS_PATIENTS_SET,
  kits
});

export const actionUpdateKitStatus = (kitId, status) => ({
  type: CONSTANTS.KIT_PATIENTS_UPDATE_STATUS,
  kitId,
  status
});